// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/EventCustomer/EventCustomer.css
// module id = 1171
// module chunks = 0